import Api from "app/services/common/Api";
import {
  SearchModel,
  WorkGhgsBzkndModel,
  WorkGhgsStatTrendModel,
} from "app/model/work/workGhgsModel";

export class WorkGhgsService extends Api {
  private static service: WorkGhgsService;

  public static getInstance(): WorkGhgsService {
    if (!WorkGhgsService.service) {
      WorkGhgsService.service = new WorkGhgsService();
    }
    return WorkGhgsService.service;
  }

  public async getColumnChartEmissionsByBzknd(param: SearchModel) {
    const url = process.env.REACT_APP_URL_CP + "/EmissionsStatus/admin/bzknd/column";
    return await super.get<WorkGhgsStatTrendModel>(url, param);
  }

  public async getEmissionsByBzknds(param: any) {
    const url = process.env.REACT_APP_URL_CP + "/EmissionsStatus/admin/bzknds/pie";
    return await super.get<WorkGhgsBzkndModel[]>(url, param);
  }

  public async getEmissionsByBzkndsAndFacl(param: any) {
    const url = process.env.REACT_APP_URL_CP + "/EmissionsStatus/admin/bzknd/facl";
    return await super.get<WorkGhgsBzkndModel[]>(url, param);
  }

}